import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Extras from '../../components/Extras/Extras';
import { selectAccessoryRequest } from '../../actions/personalization';

const ExtrasContainer = () => {
  const dispatch = useDispatch();
  const { tipo, modelo, version, anio, color } = useParams();
  const { personalization } = useSelector(state => ({
    personalization: state?.personalization,
  }));
  const selectAccessory = useCallback(
    accessory => {
      dispatch(
        selectAccessoryRequest(tipo, modelo, version, anio, color, accessory)
      );
    },
    [anio, color, dispatch, modelo, tipo, version]
  );
  return <Extras extras={personalization} selectAccessory={selectAccessory} />;
};

export default ExtrasContainer;
